/* ---------- NYL CUSTOM JS - BEGIN------------ */

$(document).ready(function() {
  
    var tabUl = "<ul class='nyl-description-tabs'>"
    var contentDiv = "<div class='nyl-description-container'>"
    var html = ""
    
    
    $(".rte-content table tr").each(function(index) {
      if(index === 0) {
        tabUl += "<li class='active' "
        contentDiv += "<div class='active "
      } else {
        tabUl += "<li "
        contentDiv += "<div class='"
      }
      tabUl += "tabId='" + index + "'>" + $(this).find("td:first-child").text() + "</li>"
      contentDiv += "tabContainer" + index + "'>" + $(this).find("td:first-child").next().text() + "</div>"
    });
  
  
  	tabUl += "</ul>"
    contentDiv += "<div>"
    html += tabUl + contentDiv
    
    
    $(".rte-content table").remove()
    $(".rte-content").append(html)
    
    $('.nyl-description-tabs li').click(function(e){
      $('.nyl-description-tabs li').removeClass('active');
 	  $(this).addClass('active');
	  $('.nyl-description-container div').removeClass('active');
      var tabID = '.tabContainer' + $(this).attr('tabId')
      console.log(tabID)
      $(tabID).addClass('active');
    });
  

    $('.showOverlay').click(function(e){
      $('.readMoreOverlay').css("display","flex")
      var oid = $(this).attr("oid")
      $('#readMoreOverlay_' + oid).show()
    });
  
  	
  	$('.readMoreOverlay, .closeOverlay').click(function(e){
      $('.readMoreOverlay').css("display","none")
      $('.readMoreOverlay div').css("display","none")
    });
  
  	$('.readMoreOverlay div').click(function(e){
      e.stopPropagation();
    });

});
  